"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJKGeoSuggest = void 0;
var _ramda = require("ramda");
var _suggestNewbuilding = require("../../shared/repositories/geo-suggest/v1/suggest-newbuilding");
var _requestActions = require("./requestActions");
var _geosuggestErrorMessages = require("../../constants/geosuggestErrorMessages");
/* eslint-disable  @typescript-eslint/no-explicit-any */

const processResponce = res => {
  if (res.statusCode === 200) {
    const suggestLength = (0, _ramda.path)(['response', 'suggestions', 'newbuildings', 'length'], res);
    if (suggestLength) {
      /**
       * Проблема с типами возникает по 2м причинам:
       *   * в апи поле matches типизировано как number[][], а надо [number, number][]  - это не проблема
       *   * в поле type несовместимость enamок - доверяем
       * */
      return (0, _requestActions.successAction)(res.response);
    }
  }
  return (0, _requestActions.failureAction)(_geosuggestErrorMessages.NEWBUILDINGS_NOT_FOUND_ERROR);
};

/**
 * Геосаджест для ЖК
 * Использует нашу апи
 * */
const getJKGeoSuggest = addressChunk => (dispatch, getState, context) => {
  const {
    httpApi
  } = context;
  const {
    subdomain
  } = getState();
  dispatch((0, _requestActions.requestAction)());
  return (0, _suggestNewbuilding.fetchSuggestNewbuilding)({
    httpApi,
    parameters: {
      query: addressChunk.trim(),
      subdomain
    }
  }).then(res => {
    const action = processResponce(res);
    dispatch(action);
  }).catch(() => {
    dispatch((0, _requestActions.failureAction)(_geosuggestErrorMessages.SERVER_ERROR));
  });
};
exports.getJKGeoSuggest = getJKGeoSuggest;